import {createSelector, MemoizedSelector, MemoizedSelectorWithProps} from '@ngrx/store';
import {REPLACEMENT_STOCK_ITEMS_FEATURE_KEY, selectWarehouseModuleState} from '../reducers';
import {ApplicationState} from '../../../application-state/store';
import {generateBaseSelectors} from '../../../shared/utilities/selector.utilities';
import {ReplacementStockItem} from '../../models';
import {State} from '../reducers/replacement-stock-items.reducers';

type BaseType = ReplacementStockItem;
type StateType = State;
const NAMESPACE = REPLACEMENT_STOCK_ITEMS_FEATURE_KEY;
const MODULE_STATE_SELECT = selectWarehouseModuleState;

export const {
  sState,
  isLoading,
  isLoaded,
  sEntities,
  sList,
  sById,
  sByIri
}: {
  isLoading: MemoizedSelector<ApplicationState, boolean>;
  sById: (id) => MemoizedSelector<ApplicationState, BaseType>;
  sByIri: MemoizedSelectorWithProps<ApplicationState, { readonly iri?: string }, BaseType>;
  sEntities: MemoizedSelector<ApplicationState, { [iri: string]: BaseType }>;
  sList: MemoizedSelector<ApplicationState, Array<BaseType>>;
  sState: MemoizedSelector<ApplicationState, StateType>;
  isLoaded: MemoizedSelector<ApplicationState, boolean>
} = generateBaseSelectors(MODULE_STATE_SELECT, NAMESPACE);

//////////////////////////////////////////////////////////////////////////////////////////////////////////////// Errors

export const selectErrors = createSelector(
  sState,
  (state) => state.errors
);
